import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
var noLogs = true;
var contentElementIDs = 0;
var ContentElement = /** @class */ (function (_super) {
    __extends(ContentElement, _super);
    function ContentElement(elementFormat, eventMirror, textRotation) {
        if (elementFormat === void 0) { elementFormat = null; }
        if (eventMirror === void 0) { eventMirror = null; }
        if (textRotation === void 0) { textRotation = 'rotate0'; }
        var _this = _super.call(this) || this;
        _this._id = contentElementIDs++;
        _this._elementFormat = elementFormat;
        _this._eventMirror = eventMirror;
        _this._textRotation = axCoerceString(textRotation);
        noLogs || console.log('[ContentElement] constructor ' + _this._id
            + ' elementFormat', elementFormat
            + ' eventMirror', eventMirror
            + ' textRotation', textRotation);
        return _this;
    }
    ContentElement.prototype.setTextBlock = function (value) {
        noLogs || console.log('[ContentElement]  ' + this._id + ' - setTextBlock', this._textBlock);
        this._textBlock = value;
    };
    ContentElement.prototype.setGroupElement = function (value) {
        noLogs || console.log('[ContentElement]  ' + this._id + ' - setGroupElement', value);
        this._groupElement = value;
    };
    Object.defineProperty(ContentElement.prototype, "textBlock", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get textBlock', this._textBlock);
            return this._textBlock;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "textBlockBeginIndex", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get textBlockBeginIndex', this._textBlockBeginIndex);
            return this._textBlockBeginIndex;
        },
        set: function (value) {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - set textBlock', this._textBlock);
            this._textBlockBeginIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "elementFormat", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get elementFormat', this._elementFormat);
            return this._elementFormat;
        },
        set: function (value) {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - set elementFormat', value);
            this._elementFormat = value;
            if (this._textBlock)
                this._textBlock.setTextDataDirty();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "eventMirror", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get eventMirror', this._eventMirror);
            return this._eventMirror;
        },
        set: function (value) {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - set eventMirror', value);
            this._eventMirror = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "groupElement", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get groupElement', this._groupElement);
            return this._groupElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "rawText", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get rawText', this._rawText);
            return this._rawText;
        },
        set: function (value) {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - set rawText', value);
            this._rawText = value;
            this._text = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "text", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get text', this._text);
            return this._text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentElement.prototype, "textRotation", {
        get: function () {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - get textRotation', this._textRotation);
            return this._textRotation;
        },
        set: function (value) {
            noLogs || console.log('[ContentElement]  ' + this._id + ' - set textRotation', value);
            this._textRotation = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    ContentElement.forceNativeConstructor = true;
    ContentElement.forceNativeMethods = true;
    // JS -> AS Bindings
    ContentElement.GRAPHIC_ELEMENT = 65007;
    return ContentElement;
}(ASObject));
export { ContentElement };
